export default function JobCardSkeleton() {
  return (
    <div className="card-flat animate-pulse">
      <div className="flex items-start justify-between gap-3">
        <div className="h-3 w-20 rounded bg-muted" />
        <div className="h-6 w-16 rounded-full bg-muted" />
      </div>
      <div className="mt-3 h-6 w-3/4 rounded bg-muted" />
      <div className="mt-2 flex items-center gap-1.5">
        <div className="h-4 w-4 rounded-full bg-muted" />
        <div className="h-3 w-24 rounded bg-muted" />
      </div>
      <div className="mt-4 flex flex-wrap gap-3">
        <div className="h-3 w-20 rounded bg-muted" />
        <div className="h-3 w-24 rounded bg-muted" />
      </div>
      <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
        <div className="h-7 w-16 rounded bg-muted" />
        <div className="h-3 w-20 rounded bg-muted" />
      </div>
    </div>
  );
}